module.exports = __webpack_public_path__ + "img/expanding-blue.d4c62d52.svg";